/** Share authentication only with annotation tools served on this same host. */
export function writeToolTokenCookie(token: string | undefined): void {
  const hostname = window.location.hostname;
  const cookieName = `${hostname} token`;
  const attributes = `;path=/;SameSite=Lax${window.location.protocol === 'https:' ? ';Secure' : ''}`;
  const expired = 'Thu, 01 Jan 1970 00:00:00 GMT';

  // Remove the previous explicit-Domain variant for this host, not parent or sibling domains.
  document.cookie = `${cookieName}=;domain=${hostname};expires=${expired}${attributes}`;
  document.cookie = `${cookieName}=${token || ''};expires=${token ? 'Fri, 31 Dec 9999 23:59:59 GMT' : expired}${attributes}`;
}
